import React, { useEffect, useRef } from 'react';
import { ArrowDown } from 'lucide-react';

const HeroModern = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {
        // Video autoplay failed - silent error handling
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background - Ben Visibile */}
      <div className="absolute inset-0 z-0">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          webkit-playsinline="true"
          preload="auto"
          disablePictureInPicture
          controls={false}
          className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        >
          <source src="https://customer-assets.emergentagent.com/job_grano-v2/artifacts/vxfowyiu_SnapInsta.to_AQNBRMJbH4juL4yAUjhvMMigl4_iHOKUBc1CnYQJCxyzvk_srUD6dPuTXJ9Zv8hURoBmYyx2BDeDNQY3luMPfNRgB4mOfxmrKTSukus.mp4" type="video/mp4" />
        </video>
        {/* Overlay leggero per leggibilità */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-5xl mx-auto space-y-8 animate-fade-in-up">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_grano-v2/artifacts/rir9eg3m_LOGO-FOOTER-e1715783553327-1024x426.png"
              alt="Grano e Sale"
              className="h-32 md:h-48 w-auto animate-fade-in"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>

          {/* Tagline */}
          <div className="py-6">
            <p className="text-xl md:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed">
              Sapore, tradizione e allegria nel cuore dell'Umbria dal 2003
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <a
              href="#prenota"
              className="px-10 py-4 bg-[#7f9e60] text-white text-lg font-semibold rounded-full hover:bg-[#6a8550] transition-all duration-300 hover:scale-105 shadow-2xl"
            >
              Prenota un Tavolo
            </a>
            <a
              href="https://f9vvvv5kmoeqspr7aqgpyobkuwn6tcl1.pages.pienissimo.pro/?id=0VY9ap"
              target="_blank"
              rel="noopener noreferrer"
              className="px-10 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full border-2 border-white/50 hover:bg-white hover:text-[#7f9e60] transition-all duration-300"
            >
              Scopri il Menu
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#welcome" className="flex flex-col items-center space-y-2 text-white/70 hover:text-white transition-colors">
          <span className="text-sm uppercase tracking-wider">Scorri</span>
          <ArrowDown size={24} />
        </a>
      </div>
    </section>
  );
};

export default HeroModern;
